module.exports = __webpack_public_path__ + "media/images/cleaning/meriem@2x-623cb34708e7bc4bb4125d1c7d2e94a5.jpg";